import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import { api, UserContext } from "../utils";

export default function CustomerTypeahead(props) {
   const userCtx = useContext(UserContext);
   const [inputValue, setInputValue] = useState("");

   useEffect(() => {
      if (userCtx && userCtx.currentUser) {
         api
            .fetch(`Cart/ActiveCarts`)
            .then((response) => {
               if (response.data.success) {
                  userCtx.setActiveCarts(response.data.activeCarts);
               } else {
                  userCtx.setActiveCarts([]);
               }
            })
            .catch(api.catchHandler);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const loadOptions = (typedValue, callback) => {
      if (!typedValue || !typedValue.length || typedValue.length < 2) {
         return;
      }

      api
         .fetch("Customer/CustomerTypeAhead", { searchString: typedValue })
         .then((response) => {
            const list = _.map(response.data, (d) => ({
               label: d.name,
               value: d.id,
            }));
            callback(list);
         })
         .catch(() => {
            toast.error("There was an error loading customer information.");
            callback([]);
         });
   };

   function selectCustomer(newCustomer) {
      if (props.userProfile) return;
      if (userCtx && userCtx.setCustomerFilter) {
         userCtx.setCustomerFilter(newCustomer);
         if (newCustomer && newCustomer.value) {
            userCtx.loadCart(newCustomer.value);
         } else {
            userCtx.loadActiveCarts();
         }
         props.onChange(newCustomer);
      }
   }

   return (
      <AsyncSelect
         classNamePrefix="serviceThreadSelect"
         loadOptions={loadOptions}
         onInputChange={(e) => setInputValue(e)}
         onChange={selectCustomer}
         inputValue={inputValue}
         value={props.value}
         isDisabled={props.disabled}
         onFocus={props.onFocus}
         isClearable
         placeholder={ props.placeholder || "Type the customer number you are looking for" }
      />
   );
}
